function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1932(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 26.85,
    height: 10.62,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.3275
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.425,
    y: 5.31
  }, "\n        Hamilton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 10.62,
    width: 26.85,
    height: 26.78,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.3475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.425,
    y: 24.009999999999998
  }, "\n        Schuyler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 37.4,
    width: 26.85,
    height: 33.13,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.4750000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.425,
    y: 53.965
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 70.53,
    width: 26.85,
    height: 33.41,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.37
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.425,
    y: 87.235
  }, "\n        Yates\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 103.94,
    width: 26.85,
    height: 40.16,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.9833333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.425,
    y: 124.02
  }, "\n        Schoharie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 144.1,
    width: 26.85,
    height: 40.57,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.37
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.425,
    y: 164.385
  }, "\n        Lewis\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 184.67,
    width: 26.85,
    height: 44.71,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.4750000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.425,
    y: 207.02499999999998
  }, "\n        Seneca\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 229.38,
    width: 26.85,
    height: 47.98,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.37
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.425,
    y: 253.37
  }, "\n        Tioga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 277.36,
    width: 26.85,
    height: 55.02,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.835714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.425,
    y: 304.87
  }, "\n        Wyoming\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 332.39,
    width: 26.85,
    height: 55.51,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.4750000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.425,
    y: 360.145
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 387.89,
    width: 26.85,
    height: 55.74,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.835714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.425,
    y: 415.76
  }, "\n        Orleans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 443.63,
    width: 26.85,
    height: 56.77,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.35625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.425,
    y: 472.015
  }, "\n        Cortland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 500.4,
    width: 26.85,
    height: 61.44,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.37
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.425,
    y: 531.12
  }, "\n        Essex\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 561.84,
    width: 26.85,
    height: 68.97,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.35625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.425,
    y: 596.325
  }, "\n        Chenango\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 630.81,
    width: 26.85,
    height: 69.19,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.35625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.425,
    y: 665.405
  }, "\n        Allegany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.85,
    y: 0,
    width: 39.37,
    height: 47.49,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.937
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 46.535,
    y: 23.745
  }, "\n        Livingston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 66.22,
    y: 0,
    width: 40.35,
    height: 47.49,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.764285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 86.395,
    y: 23.745
  }, "\n        Genesee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 106.57,
    y: 0,
    width: 40.47,
    height: 47.49,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.745
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 126.80499999999999,
    y: 23.745
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 147.04,
    y: 0,
    width: 40.75,
    height: 47.49,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.09375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 167.415,
    y: 23.745
  }, "\n        Sullivan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 187.79,
    y: 0,
    width: 41.63,
    height: 47.49,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.20375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 208.605,
    y: 23.745
  }, "\n        Tompkins\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 229.42,
    y: 0,
    width: 42.41,
    height: 47.49,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.058571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 250.625,
    y: 23.745
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 271.83,
    y: 0,
    width: 42.62,
    height: 47.49,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.088571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 293.14,
    y: 23.745
  }, "\n        Clinton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 314.44,
    y: 0,
    width: 43.7,
    height: 47.49,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.4625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 336.29,
    y: 23.745
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 358.14,
    y: 0,
    width: 43.97,
    height: 47.49,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.49625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 380.125,
    y: 23.745
  }, "\n        Delaware\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 402.11,
    y: 0,
    width: 46.06,
    height: 47.49,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.7575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 425.14,
    y: 23.745
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 448.17,
    y: 0,
    width: 46.19,
    height: 47.49,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.698333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 471.265,
    y: 23.745
  }, "\n        Fulton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 494.36,
    y: 0,
    width: 48.82,
    height: 47.49,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.7490000000000006
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 518.77,
    y: 23.745
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 543.18,
    y: 0,
    width: 49.9,
    height: 47.49,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.498000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 568.13,
    y: 23.745
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 593.08,
    y: 0,
    width: 51.2,
    height: 47.49,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.915
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 618.6800000000001,
    y: 23.745
  }, "\n        Otsego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 644.28,
    y: 0,
    width: 55.72,
    height: 47.49,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.784285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 672.14,
    y: 23.745
  }, "\n        Ontario\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.85,
    y: 47.49,
    width: 56.15,
    height: 48.53,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.853
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.925,
    y: 71.755
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.85,
    y: 96.02,
    width: 56.15,
    height: 49.86,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.2325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.925,
    y: 120.94999999999999
  }, "\n        Herkimer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.85,
    y: 145.89,
    width: 56.15,
    height: 52.08,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.51
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.925,
    y: 171.92999999999998
  }, "\n        Rockland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.85,
    y: 197.97,
    width: 56.15,
    height: 57.3,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.1045454545454545
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.925,
    y: 226.62
  }, "\n        Cattaraugus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.85,
    y: 255.27,
    width: 56.15,
    height: 57.78,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.358333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.925,
    y: 284.16
  }, "\n        Cayuga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.85,
    y: 313.05,
    width: 56.15,
    height: 58.78,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.01875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.925,
    y: 342.44
  }, "\n        Saratoga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.85,
    y: 371.83,
    width: 56.15,
    height: 59.94,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.358333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.925,
    y: 401.79999999999995
  }, "\n        Oswego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.85,
    y: 431.76,
    width: 56.15,
    height: 64.68,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.02142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.925,
    y: 464.1
  }, "\n        Chemung\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.85,
    y: 496.44,
    width: 56.15,
    height: 66.41,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.679166666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.925,
    y: 529.645
  }, "\n        St._Lawrence\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.85,
    y: 562.85,
    width: 56.15,
    height: 68.35,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.238888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.925,
    y: 597.025
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.85,
    y: 631.21,
    width: 56.15,
    height: 68.79,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.02142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.925,
    y: 665.605
  }, "\n        Steuben\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 83,
    y: 47.49,
    width: 59.14,
    height: 70.19,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.856666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 112.57,
    y: 82.58500000000001
  }, "\n        Ulster\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 142.14,
    y: 47.49,
    width: 69.79,
    height: 70.19,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.72375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 177.035,
    y: 82.58500000000001
  }, "\n        Dutchess\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 211.93,
    y: 47.49,
    width: 74.86,
    height: 70.19,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.019
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 249.36,
    y: 82.58500000000001
  }, "\n        Chautauqua\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 286.79,
    y: 47.49,
    width: 78.75,
    height: 70.19,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.027142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 326.165,
    y: 82.58500000000001
  }, "\n        Niagara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 365.54,
    y: 47.49,
    width: 79.47,
    height: 70.19,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.380909090909091
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 405.27500000000003,
    y: 82.58500000000001
  }, "\n        Schenectady\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 445,
    y: 47.49,
    width: 81.03,
    height: 70.19,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.698333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 485.515,
    y: 82.58500000000001
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 526.03,
    y: 47.49,
    width: 84.12,
    height: 70.19,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.698333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 568.0899999999999,
    y: 82.58500000000001
  }, "\n        Broome\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 610.15,
    y: 47.49,
    width: 89.85,
    height: 70.19,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.77375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 655.0749999999999,
    y: 82.58500000000001
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 83,
    y: 117.68,
    width: 110.55,
    height: 60.71,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.071
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 138.275,
    y: 148.035
  }, "\n        Rensselaer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 83,
    y: 178.39,
    width: 110.55,
    height: 68.57,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.795714285714284
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 138.275,
    y: 212.67499999999998
  }, "\n        Suffolk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 83,
    y: 246.95,
    width: 110.55,
    height: 76.71,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.784999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 138.275,
    y: 285.305
  }, "\n        Oneida\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 83,
    y: 323.67,
    width: 110.55,
    height: 114.16,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 18.425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 138.275,
    y: 380.75
  }, "\n        Albany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 83,
    y: 437.83,
    width: 110.55,
    height: 125.94,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.81875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 138.275,
    y: 500.79999999999995
  }, "\n        Onondaga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 83,
    y: 563.77,
    width: 110.55,
    height: 136.23,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 18.425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 138.275,
    y: 631.885
  }, "\n        Nassau\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 193.55,
    y: 117.68,
    width: 136.56,
    height: 142.32,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 22.76
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 261.83000000000004,
    y: 188.84
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 330.1,
    y: 117.68,
    width: 162.13,
    height: 142.32,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.938181818181818
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 411.165,
    y: 188.84
  }, "\n        Westchester\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 492.24,
    y: 117.68,
    width: 207.76,
    height: 142.32,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 35.58
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 596.12,
    y: 188.84
  }, "\n        Erie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 193.55,
    y: 260,
    width: 189.55,
    height: 219.51,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 31.59166666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 288.32500000000005,
    y: 369.755
  }, "\n        Queens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 193.55,
    y: 479.51,
    width: 189.55,
    height: 220.49,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 37.910000000000004
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 288.32500000000005,
    y: 589.755
  }, "\n        Bronx\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 383.1,
    y: 260,
    width: 316.9,
    height: 186.4,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 23.3
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 541.55,
    y: 353.2
  }, "\n        New_York\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 383.1,
    y: 446.39,
    width: 316.9,
    height: 253.61,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 50.722
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 541.55,
    y: 573.1949999999999
  }, "\n        Kings\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1932);
export default __webpack_public_path__ + "static/media/1932.09901687737729e2566476ed20e9534c.svg";
export { ForwardRef as ReactComponent };